import { Injectable } from "@angular/core";
import { SwUpdate, VersionEvent, VersionReadyEvent } from "@angular/service-worker";
import { from, interval, of } from "rxjs";
import { catchError, concatMap, filter, startWith, tap } from "rxjs/operators";

// TODO TB : Regrouper avec l'updateService
@Injectable({
	providedIn: "root"
})
export class PwaUpdateService {
	//#region FIELDS

	private readonly C_LOG_ID = "PWAUPDT.S::";

	/** Indique si le service est déjà en train de vérifier la mise à jour. */
	private lbChecking = false;

	//#endregion

	//#region METHODS

	constructor(private readonly ioSwUpdate: SwUpdate) {}

	private async updateApp(): Promise<void> {
		if (confirm("Une nouvelle version est disponible. Voulez-vous la charger?")) {
			await this.ioSwUpdate.activateUpdate(); // Si l'utilisateur valide, on l'applique puis on reload.
			window.location.reload();
		}
	}

	/** Initialise la détection de mises à jour. La recherche se fait toutes les minutes. */
	public initUpdateCheck(): void {
		if (this.ioSwUpdate.isEnabled && !this.lbChecking) {
			this.lbChecking = true;

			this.ioSwUpdate.unrecoverable.subscribe((poEvent) => {
				console.error(`${this.C_LOG_ID}SW unrecoverable state: ${poEvent.reason}. Reloading.`);
				window.location.reload();
			});

			this.ioSwUpdate.versionUpdates
				.pipe(
					tap((poEvent: VersionEvent) => console.debug(`${this.C_LOG_ID}SW version event: ${poEvent.type}.`)),
					filter((poEvent: VersionEvent): poEvent is VersionReadyEvent => poEvent.type === "VERSION_READY"),
					concatMap(() => this.updateApp())
				)
				.subscribe();

			interval(60000)
				.pipe(
					startWith(0),
					concatMap(() =>
						from(this.ioSwUpdate.checkForUpdate()).pipe(
							catchError((poError: unknown) => {
								console.error(`${this.C_LOG_ID}checkForUpdate failed.`, poError);
								return of(false);
							})
						)
					),
					tap((pbHasUpdate: boolean) =>
						console.debug(`${this.C_LOG_ID}Webapp update checked. New version available: ${pbHasUpdate}.`)
					)
				)
				.subscribe();
		} else {
			console.debug(`${this.C_LOG_ID}SW updates not enabled (isEnabled=${this.ioSwUpdate.isEnabled}).`);
		}
	}

	//#endregion
}
